import React, { useState } from 'react';
import { connect } from 'react-redux';
import UIFx from 'uifx';

import { Delay } from '../../utils/delay';

import TwilightZoneHome from './TwilightZoneHome';
import TwilightZoneStage from './TwilightZoneStage';
import TwilightZoneStageBoss from './TwilightZoneStageBoss';
import TwilightZoneStageVideo from './TwilightZoneStageVideo';
import styled from 'styled-components';
import { useImagesContext } from '../../contexts/ImagesContext';

import selectStageFile from './sounds/select-stage.mp3';
import getYardnapha from './sounds/get-yardnapha.mp3';
import ReactSound from 'react-sound';

const selectStage = new UIFx(selectStageFile);

const PAGES = {
  HOME: 'HOME',
  STAGE: 'STAGE',
  STAGE_BOSS: 'STAGE_BOSS',
  STAGE_VIDEO: 'STAGE_VIDEO',
};

const TwilightZone = ({ history, student, config }) => {
  const [twilightZoneId, setTwilightZoneId] = useState(null);
  const [stage, setStage] = useState(null);
  const [twilightZone, setTwilightZone] = useState(null);
  // const [stage, setStage] = useState({
  //   id: 7,
  //   number: 2,
  //   title: null,
  //   image: '/files/twilight_zone/c0533de6-8180-46a9-a9f5-eac4db27495a.png',
  //   imageTop: 501,
  //   imageLeft: 1200,
  //   walkTop: 500,
  //   walkLeft: 1000,
  //   stageType: 'boss',
  //   video: '',
  //   issueYardnapha: 2,
  //   bossRank: 'S',
  //   createdAt: '2024-11-07T07:47:54.000Z',
  //   updatedAt: '2024-11-10T04:00:41.000Z',
  //   twilightZoneId: 1,
  //   isPass: false,
  //   canAccess: true,
  // });
  // const [twilightZone, setTwilightZone] = useState({
  //   id: 1,
  //   title: '',
  //   bossBackground:
  //     '/files/twilight_zone/a0a29277-1118-4601-adb5-e9bcf2b57e8b.jpg',
  // });

  const [issueYardnapha, setIssueYardnapha] = useState(null);
  const { images } = useImagesContext();
  let page = PAGES.HOME;
  if (twilightZoneId) {
    page = PAGES.STAGE;
  }
  if (stage && stage.stageType === 'boss') {
    page = PAGES.STAGE_BOSS;
  }
  if (stage && stage.stageType === 'video') {
    page = PAGES.STAGE_VIDEO;
  }

  const handleStageBack = () => {
    setStage(null);
  };

  const handleStageCompleted = (issueYardnapha) => {
    setIssueYardnapha(issueYardnapha);
    setTimeout(() => {
      setIssueYardnapha(null);
    }, 2000);
    setStage(null);
  };

  return (
    <>
      {page === PAGES.HOME && (
        <TwilightZoneHome
          handleBack={() => history.goBack()}
          selectTwilightZoneId={async (twilightZoneId) => {
            if (!config.isMutedSound) {
              selectStage.play();
              await Delay(1000);
            }
            setTwilightZoneId(twilightZoneId);
          }}
        />
      )}
      {page === PAGES.STAGE && (
        <TwilightZoneStage
          student={student}
          twilightZoneId={twilightZoneId}
          handleBack={() => setTwilightZoneId(null)}
          handleStageSelected={async (stage, twilightZone) => {
            setTwilightZone(twilightZone);
            setStage(stage);
          }}
        />
      )}
      {page === PAGES.STAGE_BOSS && (
        <TwilightZoneStageBoss
          handleBack={() => {
            setStage(null);
          }}
          stage={stage}
          twilightZone={twilightZone}
          handleCompleted={() => {
            setStage(null);
          }}
        />
      )}
      {page === PAGES.STAGE_VIDEO && (
        <TwilightZoneStageVideo
          stage={stage}
          handleBack={handleStageBack}
          handleCompleted={handleStageCompleted}
        />
      )}
      {issueYardnapha > 0 && (
        <ReactSound
          url={getYardnapha}
          playStatus={ReactSound.status.PLAYING}
          volume={config.isMutedSound ? 0 : 100}
        ></ReactSound>
      )}
      <IssueYardnapha
        src={
          issueYardnapha === 1 ? images[`video-yardnapha-issue-one.png`] : null
        }
      />
      <IssueYardnapha
        src={
          issueYardnapha === 2 ? images[`video-yardnapha-issue-two.png`] : null
        }
      />
    </>
  );
};

const IssueYardnapha = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const mapStateToProps = ({ student, config }) => ({
  student,
  config,
});

export default connect(mapStateToProps, null)(TwilightZone);
